import { ReactElement, ReactNode } from 'react'

interface ConditionalWrapperProps {
  condition: boolean
  wrapper: (children: ReactNode) => ReactElement
  children: ReactNode
}

/**
 * Wrapper component that conditionally wraps children based on a boolean condition.
 * This is useful for applying styles or additional functionality only when a certain condition is met
 * and avoids unnecessary code duplication.
 * An Example is a component that conditionally applies a wrapper like a Label or a Box
 * around its children based on a prop.
 * @param param0.condition Boolean condition to determine if the wrapper should be applied.
 * @param param0.wrapper Function that takes children and returns a JSX element to wrap them.
 * @param param0.children The children to be conditionally wrapped.
 * @returns
 */
export const GenericConditionalWrapper = ({
  condition,
  wrapper,
  children
}: ConditionalWrapperProps) => (condition ? wrapper(children) : children)
